import React from 'react';
const validCounter = value => Number.isSafeInteger(value) && value >= 0;
function validDate(value) {
  if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
  const time = new Date(`${value}T00:00:00Z`);
  return Number.isFinite(time.getTime()) && time.toISOString().slice(0, 10) === value;
}
function validTimestamp(value) {
  return typeof value === 'string'
    && /^\d{4}-\d{2}-\d{2}T(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d(?:\.\d+)?(?:Z|[+-](?:[01]\d|2[0-3]):[0-5]\d)$/.test(value)
    && validDate(value.slice(0, 10)) && Number.isFinite(Date.parse(value));
}
export function validInterest(snapshot) {
  if (snapshot?.schema_version !== 1 || snapshot.timezone !== 'Asia/Seoul' || !validDate(snapshot.as_of_date) || !validTimestamp(snapshot.updated_at) || !Array.isArray(snapshot.items) || snapshot.items.length > 100) return false;
  const earliest = new Date(`${snapshot.as_of_date}T00:00:00Z`);
  earliest.setUTCDate(earliest.getUTCDate() - 6);
  const firstDate = earliest.toISOString().slice(0, 10);
  const ids = new Set();
  return snapshot.items.every(item => {
    if (!item || typeof item.plaza_id !== 'string' || !item.plaza_id || ids.has(item.plaza_id) || !validCounter(item.total_views) || !validCounter(item.total_explores) || !Array.isArray(item.daily) || item.daily.length > 7) return false;
    ids.add(item.plaza_id);
    const dates = new Set();
    let views = 0; let explores = 0;
    const valid = item.daily.every(day => {
      if (!day || !validDate(day.date) || day.date > snapshot.as_of_date || day.date < firstDate || dates.has(day.date) || !validCounter(day.views) || !validCounter(day.explores)) return false;
      dates.add(day.date); views += day.views; explores += day.explores; return true;
    });
    return valid && views <= item.total_views && explores <= item.total_explores;
  });
}
export function counterLabel(value, locale) { return validCounter(value) ? value.toLocaleString(locale) : '—'; }
export function interestItem(snapshot, id) { return validInterest(snapshot) ? snapshot.items.find(item => item.plaza_id === id) || null : null; }
export default function PlazaInterest({ snapshot, plazaId, copy }) {
  const item = interestItem(snapshot, plazaId);
  if (!item) return <p>{copy.interestUnknown}</p>;
  const days = [...item.daily].sort((a, b) => b.date.localeCompare(a.date));
  return <section aria-label={copy.recentInterest}>
    <p>{copy.totalViews}: {counterLabel(item.total_views, copy.locale)} · {copy.totalExplores}: {counterLabel(item.total_explores, copy.locale)}</p>
    <p>{copy.interestAsOf}: {snapshot.as_of_date}</p>
    <details><summary>{copy.recentInterest}</summary><table><thead><tr><th>{copy.interestDate}</th><th>{copy.views}</th><th>{copy.explores}</th></tr></thead><tbody>{days.map(day => <tr key={day.date}><td>{day.date}</td><td>{counterLabel(day.views, copy.locale)}</td><td>{counterLabel(day.explores, copy.locale)}</td></tr>)}</tbody></table></details>
  </section>;
}
